<!--
@name: 弹窗组件
@description: 描述
@author: 作者
@time: 2024-05-27 09:50:52
-->

<template>
  <el-drawer
    v-model="drawerVisible"
    :title="title"
    :destroy-on-close="destroyOnClose"
    :append-to-body="appendToBody"
    :direction="direction"
    :size="size"
    :with-header="withHeader"
    :show-close="showClose"
    modal-class="tl-drawer"
  >
    <slot name="header" />
    <slot name="default" />
    <slot name="footer" />
  </el-drawer>
</template>
<script setup>
defineProps({
  direction: {
    type: String,
    default: "rtl"
  },
  withHeader: {
    type: Boolean,
    default: true
  },
  showClose: {
    type: Boolean,
    default: true
  },
  title: {
    type: String,
    default: "标题"
  },
  size: {
    type: [String, Number],
    default: "30%"
  },
  appendToBody: {
    type: Boolean,
    default: false
  },
  destroyOnClose: {
    type: Boolean,
    default: true
  }
});

const emits = defineEmits(["onDialog"]);
const drawerVisible = defineModel({ default: false });
function onDialog(value) {
  emits("onDialog", value);
}
function close() {
  console.log("弹窗关闭了", drawerVisible);
}
</script>
<style scoped lang="scss"></style>
